import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Routes, Route, Navigate, Link, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Players from './pages/Players';
import Rounds from './pages/Rounds';
import About from './pages/About';
import Majors from './pages/Majors';
import Seasons from './pages/Seasons'
import Teams from './pages/Teams';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import AuthButton from './components/AuthButton';
import ProtectedComponent from './components/ProtectedComponent';
import banner from './banner.webp';
import Courses from './pages/Courses';
import './App.css';
import Standings from './pages/Standings';
import Insights from './pages/Insights';
import Handicaps from './pages/Handicaps';
import Rules from './pages/Rules';
import Configuration from './pages/Configuration';
import 'react-quill/dist/quill.snow.css';
import { useMobile } from './hooks/useMobile';
import { useUserRegistration } from './hooks/useUserRegistration';
import Reservations from './pages/Reservations';
import WhatsAppSettings from './pages/WhatsAppSettings';
import Profile from './pages/Profile';
import MyCareer from './pages/MyCareer';
import ScorecardReview from './pages/ScorecardReview';
import PrivacyPolicy from './pages/PrivacyPolicy';
import PublicSchedule from './pages/PublicSchedule';
import Home from './pages/Home';





const App: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth0();
  const { isOnline, native } = useMobile();
  const location = useLocation();
  useUserRegistration();

  // The public landing page ("/") is shown without the app's banner/navbar/footer.
  const isLandingPage = location.pathname === '/';

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      {native && !isOnline && (
        <div style={{ background: '#c0392b', color: '#fff', textAlign: 'center', padding: '6px', fontSize: '13px' }}>
          No internet connection
        </div>
      )}
      {!isLandingPage && (
        <>
          <div id="banner">
            <img src={banner} alt="Broskies Golf Association" width= '1000' height="125" />
          </div>
          <Navbar />
        </>
      )}
      <Routes>
        {/* Public landing page — explains the app and links to the privacy policy without requiring login */}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={isAuthenticated ? <Navigate to="/" /> : <Login />} />
        {/* Public — intentionally NOT wrapped in ProtectedRoute (Google OAuth requires a publicly reachable policy) */}
        <Route path="/privacy" element={<PrivacyPolicy />} />
        {/* Public, unauthenticated: the tokenised read-only schedule link. */}
        <Route path="/schedule/:token" element={<PublicSchedule />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/rounds" element={<ProtectedRoute element={<Rounds />} />} />
        <Route path="/standings" element={<ProtectedRoute element={<Standings />} />} />
        <Route path="/insights" element={<ProtectedRoute element={<Insights />} />} />
        <Route path="/majors" element={<ProtectedRoute element={<Majors />} />} />
        <Route path="/players" element={<ProtectedRoute element={<Players />} />} />
        <Route path="/courses" element={<ProtectedRoute element={<Courses />} />} />
        <Route path="/about" element={<ProtectedRoute element={<About />} />} />
        <Route path="/seasons" element={<ProtectedRoute element={<Seasons />} />} />
        <Route path="/teams" element={<ProtectedRoute element={<Teams />} />} />
        <Route path="/handicaps" element={<ProtectedRoute element={<Handicaps />} />} />
        <Route path="/rules" element={<ProtectedRoute element={<Rules />} />} />
        <Route path="/configs" element={<ProtectedRoute element={<Configuration />} />} />
        <Route path="/reservations" element={<ProtectedRoute element={<Reservations />} />} />
        <Route path="/whatsapp-settings" element={<ProtectedRoute element={<WhatsAppSettings />} />} />
        <Route path="/profile" element={<ProtectedRoute element={<Profile />} />} />
        <Route path="/my-tasks" element={<ProtectedRoute element={<MyCareer />} />} />
        <Route path="/my-career" element={<ProtectedRoute element={<MyCareer />} />} />
        <Route path="/scorecard-review/:uploadId" element={<ProtectedRoute element={<ScorecardReview />} />} />

      </Routes>
      {!isLandingPage && (
        <footer style={{ textAlign: 'center', padding: '16px', fontSize: '12px', color: '#888' }}>
          <Link to="/privacy" style={{ color: '#888' }}>Privacy Policy</Link>
        </footer>
      )}
    </>
  );
}

export default App;
